import { states } from '@/constants/lifecycle';
import { AuthenticationState } from './constants';

export const isAuthenticated = (state) => state === AuthenticationState.Authenticated;

export const isAuthenticating = (state) => state === AuthenticationState.InProgress;

const setUserFromResponse = (response) => ({
  id: response.uuid,
  firstName: response.first_name,
  lastName: response.last_name,
  name: response.name,
  email: response.email,
  readStatus: states.SUCCESS,
  readErrors: [],
});

export default setUserFromResponse;
